import { Element, Icon, Row } from '@vuddy/components';

// react-toastify가 토스트 콘텐츠에 closeToast 같은 props를 주입하는데,
// 바로 Element에 JSX를 넣으면 해당 props가 DOM으로 전달되어 경고가 발생했습니다.
// 따라서 토스트용 래퍼 컴포넌트(AddToCartToastContent)를 만들고,
// props를 소비(무시)하도록 해서 DOM으로 전달되지 않게 했습니다.
export const AddToCartToastContent = (_props: unknown) => {
  return (
    <Row justifyContent="space-between" alignItems="center">
      <Row alignItems="center" gap="gap_small">
        <Icon name="OUTLINE_CART" width="20px" height="20px" />
        <Element typography="bodyXs" color="whitePrimary">
          상품을 장바구니에 추가했습니다.
        </Element>
      </Row>
      <Icon name="OUTLINE_CHEVRON_RIGHT" width="20px" height="20px" />
    </Row>
  );
};
